import React from 'react';
import loadable from '@loadable/component';

export default loadable(
    () =>
        import(
            /* webpackChunkName: "LazyRewardDashboardChunks" */ './RewardsSettingsScreenConnect'
        ),
    {
        fallback: <div>Loading...</div>,
    }
);
